import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center justify-start"
}
const _hoisted_2 = { style: {"min-width":"40%"} }
const _hoisted_3 = { class: "pl-2" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-end text--disabled caption"
}
const _hoisted_5 = { style: {"width":"800px"} }
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dialog) = $event)),
      title: 'Ajouter un compte bancaire',
      persistent: "",
      fullscreen: _ctx.$vuetify.display.mobile,
      "hide-overlay": _ctx.$vuetify.display.mobile,
      actions: _ctx.actions,
      "previous-display": _ctx.enableBudgetInsight && _ctx.wizardStep === 2,
      onPrevious: _ctx.previous,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeDialog())),
      prefixDataCy: "CreateBankAccount-create"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: _ctx.wizardStep,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.wizardStep) = $event)),
          touchless: "",
          style: _normalizeStyle([{"min-height":"27vh"}, {
                    minWidth: '800px',
                    maxWidth: !_ctx.$vuetify.display.mobile ? '850px' : undefined,
                }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, {
                  class: _normalizeClass(
                            !_ctx.$vuetify.display.mobile
                                ? 'title font-weight-regular justify-space-between'
                                : 'title font-weight-regular pa-1'
                        )
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createElementVNode("span", null, "Comment souhaitez vous récuperer vos opérations bancaires ?", -1)
                  ])),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_v_card_text, { class: "py-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      subheader: "",
                      lines: "three"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isTrainingOffer)
                          ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 0 }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item, _mergeProps({
                                  class: 
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        
                                }, props), {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_next)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                                        _createTextVNode("Automatiquement (recommandé)")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode("Récupération automatique et quotidienne des opérations bancaires. Nécessite de vous connecter à votre banque")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1040, ["class"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.normal-text")), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                ),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.connectClicked()))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_next)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                                    _createTextVNode("Automatiquement (recommandé)")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createTextVNode("Récupération automatique et quotidienne des opérations bancaires. Nécessite de vous connecter à votre banque")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"])),
                        (_ctx.development)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                ),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.connectMangerOne()))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_next)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode("Manager One")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode("Votre banque est Manger One ? Récupérer automatiquement et quotidiennement vos opérations bancaires et vos documents attachés.")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                ),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wizardStep = 2))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_next)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                _createTextVNode("Manuellement")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                _createTextVNode("Récupération des opérations bancaires en important manuellement un fichier csv fourni par le site de votre banque")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.isValid,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isValid) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, {
                      class: _normalizeClass(
                                !_ctx.$vuetify.display.mobile
                                    ? 'title font-weight-regular justify-space-between'
                                    : 'title font-weight-regular pa-1'
                            )
                    }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createElementVNode("span", null, "Renseignez les informations de votre compte bancaire", -1)
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_v_card_text, { class: "py-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  outlined: "",
                                  label: "Nom du compte bancaire",
                                  modelValue: _ctx.bankAccountName,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bankAccountName) = $event)),
                                  rules: [_ctx.rules.notEmpty],
                                  readlonly: _ctx.readonly,
                                  "data-cy": "CreateBankAccount-name",
                                  density: "compact"
                                }, null, 8, ["modelValue", "rules", "readlonly"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  outlined: "",
                                  label: "Nom externe",
                                  modelValue: _ctx.bankAccountExternalName,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bankAccountExternalName) = $event)),
                                  readlonly: _ctx.readonly,
                                  density: "compact"
                                }, null, 8, ["modelValue", "readlonly"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  outlined: "",
                                  label: "IBAN",
                                  modelValue: _ctx.bankAccountIban,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bankAccountIban) = $event)),
                                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInputSetTruncatedIban(_ctx.bankAccountIban))),
                                  rules: [_ctx.rules.checkIBAN],
                                  readlonly: _ctx.readonly,
                                  density: "compact",
                                  "data-cy": "CreateBankAccount-IBAN"
                                }, null, 8, ["modelValue", "rules", "readlonly"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  outlined: "",
                                  label: "BIC",
                                  modelValue: _ctx.bankAccountBic,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bankAccountBic) = $event)),
                                  rules: [_ctx.rules.checkBIC],
                                  class: "pl-2",
                                  readlonly: _ctx.readonly,
                                  density: "compact"
                                }, null, 8, ["modelValue", "rules", "readlonly"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  outlined: "",
                                  label: "Nom de la banque",
                                  readonly: "",
                                  "data-cy": "CreateBankAccount-BankName",
                                  "model-value": _ctx.bankName,
                                  density: "compact"
                                }, null, 8, ["model-value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  outlined: "",
                                  label: "Identifiant créancier sepa (ICS)",
                                  modelValue: _ctx.bankAccountICS,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bankAccountICS) = $event)),
                                  rules: [_ctx.rules.checkICS],
                                  class: "pl-2",
                                  readlonly: _ctx.readonly,
                                  density: "compact"
                                }, null, 8, ["modelValue", "rules", "readlonly"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                (!!_ctx.budgetInsightId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                      _createElementVNode("div", _hoisted_2, [
                                        _createVNode(_component_oss_date_picker_filled, {
                                          modelValue: _ctx.importStartDate,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.importStartDate) = $event)),
                                          textFieldReadOnly: false,
                                          notRequired: true,
                                          label: "Date de début d'import",
                                          readlonly: _ctx.readonly
                                        }, null, 8, ["modelValue", "readlonly"])
                                      ]),
                                      _createElementVNode("div", _hoisted_3, [
                                        (
                                                    !!_ctx.budgetInsightId &&
                                                    _ctx.beforeImportStartDateBTCount
                                                )
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deletePreviousBTDialog = true)),
                                              disabled: _ctx.readonly,
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _cache[30] || (_cache[30] = _createTextVNode(" Supprimer les flux antérieurs ")),
                                                _createVNode(_component_v_icon, {
                                                  class: "ml-2",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                    _createTextVNode("$oss-trash ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_oss_date_picker_filled, {
                                  modelValue: _ctx.startAuthorizedDate,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startAuthorizedDate) = $event)),
                                  textFieldReadOnly: false,
                                  label: "Date de clôture des flux bancaires",
                                  readlonly: _ctx.readonly,
                                  mandatory: false,
                                  clearable: true,
                                  "hide-details": "auto"
                                }, null, 8, ["modelValue", "readlonly"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                (
                                            _ctx.bankAccounts &&
                                            _ctx.bankAccounts.length &&
                                            ((_ctx.bankId && _ctx.bankAccounts.length > 1) ||
                                                (!_ctx.bankId && _ctx.bankAccounts.length))
                                        )
                                  ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                      key: 0,
                                      modelValue: _ctx.bankAccountConnect,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.bankAccountConnect) = $event)),
                                      label: "Groupe de comptes bancaires",
                                      disabled: !_ctx.bankAccountGoupIsModifiable || _ctx.readonly,
                                      items: _ctx.bankAccountsSelect,
                                      "hide-details": "",
                                      "item-value": "id",
                                      density: "compact",
                                      "item-title": (item) => item.name
                                    }, null, 8, ["modelValue", "disabled", "items", "item-title"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "style"]),
        (_ctx.companyBudgetInsightId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.companyBudgetInsightId) + " - " + _toDisplayString(_ctx.budgetInsightId), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "fullscreen", "hide-overlay", "actions", "previous-display", "onPrevious"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deletePreviousBTDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.deletePreviousBTDialog) = $event)),
      title: "Suppression des mouvements bancaires",
      onValid: _cache[18] || (_cache[18] = ($event: any) => (_ctx.deletePreviousBT())),
      validLoading: _ctx.deletePreviousBTLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.stepData || !_ctx.stepData.action)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_6, " Êtes-vous sûr(e) de vouloir supprimer les mouvements bancaires antérieurs à " + _toDisplayString(_ctx.formatDate(_ctx.importStartDate)) + " ? ", 1))
            : _createCommentVNode("", true),
          (_ctx.stepData && !!_ctx.stepData.action)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, " Suppression en cours "))
            : _createCommentVNode("", true),
          (_ctx.stepData && !!_ctx.stepData.action)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 2,
                color: "secondary",
                height: "10",
                "buffer-value": "0",
                stream: "",
                class: "ml-0",
                "model-value": _ctx.stepData.progressValue
              }, null, 8, ["model-value"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "validLoading"])
  ]))
}